/**
 * Animate one of several whimsical SVG paths to the left and right of an object on hover.
 */

import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";

import DecorationWrapper from "./decoration-wrapper.tsx";

type Props = {
    children: React.ReactElement<any>;
};

type State = {
    hovered: boolean;
};

export default class HoverDecorationWrapper extends React.Component<
    Props,
    State
> {
    state: State = {
        hovered: false,
    };

    render(): React.ReactNode {
        const {children} = this.props;
        const {hovered} = this.state;

        return (
            <View
                style={styles.hoverWrapper}
                onMouseOver={() => this.setState({hovered: true})}
                onMouseOut={() => this.setState({hovered: false})}
            >
                <DecorationWrapper decorated={hovered}>
                    {children}
                </DecorationWrapper>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    hoverWrapper: {
        flex: 1,
        flexDirection: "row",
    },
});
